module.exports = __webpack_public_path__ + "static/assets/b52d3fe7786b64f811a4034341192060.png";